module.exports = __webpack_public_path__ + "media/components/post/static/post_logo-761e3b17c409498157d9a5df2719e46c.png";